var render = function () {
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('section', {
    attrs: {
      "id": "feather-icons"
    }
  }, [_c('div', {
    staticClass: "d-flex flex-wrap",
    attrs: {
      "id": "icons-container"
    }
  }, [_c('b-card', {
    staticClass: "icon-card cursor-pointer text-center w-100 mb-2 mx-50 card-icon-new",
    staticStyle: {
      "width": "100% !important"
    }
  }, [_c('b-tabs', [_c('b-tab', {
    attrs: {
      "title": "Desafios",
      "active": "",
      "lazy": ""
    }
  }, [_c('div', {
    staticStyle: {
      "display": "flex",
      "flex-wrap": "wrap"
    }
  }, [_c('div', [_c('h3', [_vm._v("Quiz")]), _c('chartjs-component-doughnut-chart', {
    staticClass: "mb-3",
    attrs: {
      "height": 150,
      "data": _vm.dados1.data,
      "options": _vm.dados1.options
    }
  })], 1), _c('div', [_c('h3', [_vm._v("Quiz Pós Teste")]), _c('chartjs-component-doughnut-chart', {
    staticClass: "mb-3",
    attrs: {
      "height": 150,
      "data": _vm.dados1.data,
      "options": _vm.dados1.options
    }
  })], 1), _c('div', [_c('h3', [_vm._v("Patrulha Pre Teste")]), _c('chartjs-component-doughnut-chart', {
    staticClass: "mb-3",
    attrs: {
      "height": 150,
      "data": _vm.obterDadosMock(10, 90),
      "options": _vm.dados1.options
    }
  })], 1), _c('div', [_c('h3', [_vm._v("Patrulha Pós Teste")]), _c('chartjs-component-doughnut-chart', {
    staticClass: "mb-3",
    attrs: {
      "height": 150,
      "data": _vm.obterDadosMock(30, 70),
      "options": _vm.dados1.options
    }
  })], 1), _c('div', [_c('h3', [_vm._v("Janelas e Tanques Pre Teste")]), _c('chartjs-component-doughnut-chart', {
    staticClass: "mb-3",
    attrs: {
      "height": 150,
      "data": _vm.obterDadosMock(60, 40),
      "options": _vm.dados1.options
    }
  })], 1), _c('div', [_c('h3', [_vm._v("Janelas e Tanques Pós Teste")]), _c('chartjs-component-doughnut-chart', {
    staticClass: "mb-3",
    attrs: {
      "height": 150,
      "data": _vm.obterDadosMock(20, 80),
      "options": _vm.dados1.options
    }
  })], 1), _c('div', [_c('h3', [_vm._v("Coleta e Reciclagem Pre Teste")]), _c('chartjs-component-doughnut-chart', {
    staticClass: "mb-3",
    attrs: {
      "height": 150,
      "data": _vm.obterDadosMock(60, 40),
      "options": _vm.dados1.options
    }
  })], 1), _c('div', [_c('h3', [_vm._v("Coleta e Reciclagem Pós Teste")]), _c('chartjs-component-doughnut-chart', {
    staticClass: "mb-3",
    attrs: {
      "height": 150,
      "data": _vm.obterDadosMock(20, 80),
      "options": _vm.dados1.options
    }
  })], 1)])]), _c('b-tab', {
    attrs: {
      "title": "Ranking",
      "lazy": ""
    }
  }, [_c('div', {
    staticStyle: {
      "display": "flex",
      "flex-wrap": "wrap"
    }
  }, [_c('div', [_c('h3', [_vm._v("Escolas")]), _c('chartjs-component-doughnut-chart', {
    staticClass: "mb-3",
    attrs: {
      "height": 150,
      "data": _vm.dados1.data,
      "options": _vm.dados1.options
    }
  })], 1)])])], 1)], 1)], 1)]);
}
var staticRenderFns = []

export { render, staticRenderFns }